export default {
    message: {
        impersonation: "You are ordering on behalf of «{name}»"
    }
}